import { getTeamMembersListIdByParams } from "./helper";

export const teamsMembersListActions = {
  FETCH_TEAM_MEMBERS_LIST_FAILED: 'FETCH_TEAM_MEMBERS_LIST_FAILED',
  FETCH_TEAM_MEMBERS_LIST_SUCCESS: 'FETCH_TEAM_MEMBERS_LIST_SUCCESS',
  FETCH_TEAM_MEMBERS_LIST_PENDING: 'FETCH_TEAM_MEMBERS_LIST_PENDING',

  LOAD_TEAM_MEMBERS_LIST: 'LOAD_TEAM_MEMBERS_LIST',
  
  fetchTeamMembersFailed: error => ({
    type: teamsMembersListActions.FETCH_TEAM_MEMBERS_LIST_FAILED,
    payload: error
  }),

  fetchTeamMembersSuccess: (teamsMembersListId, data) => ({
    type: teamsMembersListActions.FETCH_TEAM_MEMBERS_LIST_SUCCESS,
    payload: {
      data,
      teamsMembersListId
    }
  }),

  fetchTeamMembersPending: teamsMembersListId => ({
    type: teamsMembersListActions.FETCH_TEAM_MEMBERS_LIST_PENDING,
    payload: {
      teamsMembersListId
    }
  }),

  loadTeamMembers: ({ teamId, page = 1, query = '' }) => ({
    type: teamsMembersListActions.LOAD_TEAM_MEMBERS_LIST,
    payload: {
      teamsMembersListId: getTeamMembersListIdByParams({ teamId, page, query }),
      teamId,
      page,
      query
    }
  }),

};

export const teamsMembersListRequestActions = {
  failed: teamsMembersListActions.fetchTeamMembersFailed,
  success: teamsMembersListActions.fetchTeamMembersSuccess,
  pending: teamsMembersListActions.fetchTeamMembersPending
};